import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

type FieldHintProps = React.ComponentProps<'p'>;

function FieldHint({ className, children, ...props }: FieldHintProps) {
  if (!children) return null;

  return (
    <p data-slot="field-hint" className={cn('text-muted-foreground text-xs', className)} {...props}>
      {children}
    </p>
  );
}

export { FieldHint };
